// src/components/DriverDialog.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Grid
} from '@mui/material';

function DriverDialog({ open, onClose, onSave, initialDriver }) {
  const initialDriverState = { name: '', username: '', password: '' };
  const [driver, setDriver] = useState(initialDriverState);
  const isEditMode = !!initialDriver;

  useEffect(() => {
    if (open) {
      if (initialDriver) {
        setDriver({ ...initialDriver, password: '' });
      } else {
        setDriver(initialDriverState);
      }
    }
  }, [open, initialDriver]);

  const handleChange = (e) => setDriver(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSave = () => {
    if (!driver.name || !driver.username) {
      alert('Vui lòng nhập Tên tài xế và ID đăng nhập (Email).');
      return;
    }
    const hasLogin = isEditMode && !!initialDriver.username;
    if (!hasLogin && (!driver.password || driver.password.length < 6)) {
        alert('Vui lòng nhập mật khẩu. Mật khẩu phải có ít nhất 6 ký tự.');
        return;
    }
    onSave(driver);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{isEditMode ? `Chỉnh sửa Tài xế: ${driver.name}` : 'Thêm Tài xế mới'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField name="name" label="Tên tài xế (*)" fullWidth value={driver.name} onChange={handleChange} autoFocus />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              name="username" 
              label="ID đăng nhập (Email) (*)" 
              fullWidth 
              value={driver.username || ''} 
              onChange={handleChange} 
              type="email" 
              // ### FIX IS HERE: Bỏ thuộc tính disabled ###
            />
          </Grid>
          {/* Chỉ hiển thị ô mật khẩu nếu chưa có tài khoản đăng nhập */}
          {(!isEditMode || !initialDriver.username) && (
            <Grid item xs={12}>
              <TextField
                required
                name="password"
                label="Mật khẩu (*)"
                fullWidth
                value={driver.password}
                onChange={handleChange}
                type="password"
                helperText="Mật khẩu phải có ít nhất 6 ký tự."
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button onClick={handleSave} variant="contained">Lưu</Button>
      </DialogActions>
    </Dialog>
  );
}
export default DriverDialog;
